import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Always attach the mother session token (when stored) so the backend can
// scope /submissions, /milk-logs etc. to this mother automatically.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem('mother_token');
  if (t) {
    config.headers = { ...(config.headers || {}), 'X-Mother-Token': t };
  }
  return config;
});

export const submitSelfCheck = (data) => api.post('/submissions', data).then((r) => r.data);
export const listSubmissions = () => api.get('/submissions').then((r) => r.data);
export const listConsultants = () => api.get('/consultants').then((r) => r.data);
export const listLibrary = () => api.get('/library').then((r) => r.data);
export const updateLibraryResource = (id, data, token) =>
  api.patch(`/admin/library/${id}`, data, { headers: { 'X-Admin-Token': token } }).then((r) => r.data);
export const createMilkLog = (data) => api.post('/milk-logs', data).then((r) => r.data);
export const listMilkLogs = () => api.get('/milk-logs').then((r) => r.data);
export const deleteMilkLog = (id) => api.delete(`/milk-logs/${id}`).then((r) => r.data);

// Mother profile auth
export const registerMother = (data) => api.post('/mothers/register', data).then((r) => r.data);
export const loginMother = (data) => api.post('/mothers/login', data).then((r) => r.data);
export const getMotherDashboard = () => api.get('/mothers/me/dashboard').then((r) => r.data);

export const adminLogin = (password) =>
  api.post('/admin/login', { password }).then((r) => r.data);
export const listCases = (token) =>
  api.get('/admin/cases', { headers: { 'X-Admin-Token': token } }).then((r) => r.data);
export const getCaseDetail = (caseId, token) =>
  api.get(`/admin/cases/${caseId}`, { headers: { 'X-Admin-Token': token } }).then((r) => r.data);
export const updateCase = (caseId, data, token) =>
  api.patch(`/admin/cases/${caseId}`, data, { headers: { 'X-Admin-Token': token } }).then((r) => r.data);
export const adminListMothers = (token) =>
  api.get('/admin/mothers', { headers: { 'X-Admin-Token': token } }).then((r) => r.data);
export const adminGetMother = (motherId, token) =>
  api.get(`/admin/mothers/${motherId}`, { headers: { 'X-Admin-Token': token } }).then((r) => r.data);

// WhatsApp number — sourced from env so the founder can update it without code changes
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '60132253943';
